module.exports = __webpack_public_path__ + "img/青岛啤酒.bc8edcd8.png";